// extracted by mini-css-extract-plugin
export var noPadding = "pane-module--noPadding--fc13c";
export var paneWrapper = "pane-module--pane-wrapper--2adc4";